import React from 'react'
import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'
import ModifyIconButton from './ModifyIconButton'
import { Flex } from 'reflexbox'

import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import { PROJECT_ROLES, GLOBAL_ROLES, PRODUCT_ROLES } from 'containers/Role/constants'
import { mapProps, compose } from 'recompose'

const showToTeam = compose(
  mapProps((props) => ({
    ...props,
    roles: [ 
      ...Object.values(PROJECT_ROLES),
      ...Object.values(PRODUCT_ROLES),
      GLOBAL_ROLES.ADMIN_ACCESS
    ]
  })),
  showOnAnyRoles
)

const EditButton = showToTeam(ModifyIconButton)

const Actions = ({id, onSave, edit, onEdit, toggleEdit, toggleCollapse, collapse}) => {
  return (
    <Flex justify='flex-end'>
      <EditButton
        toggleEdit={() => {
          if(!edit)onEdit()
          toggleEdit()
        }}
        edit={edit}
        onSave={onSave}
        id={id}
      />
      <CollapseIconButton
        toggleCollapse={toggleCollapse}
        collapse={collapse}
      />
    </Flex>
  )
}

export default Actions
